export default __webpack_public_path__ + "static/media/logo-loader.0796c71b.svg";